import { webOrigin } from './brand';
/**
 * The one place that decides an event's URL.
 *
 * Canonical is /e/{citySlug}/{slug} — readable, and what search indexes. It needs both parts, and
 * an event only has them when a city could be derived from its location, so the invite code stays
 * the fallback rather than an error case. Both forms serve the same page and neither redirects.
 *
 * Accepts whatever shape the caller has: a full EventDto, a card DTO, or nothing.
 */
export function eventPath(event) {
  if (!event) return null;

  const city = event.citySlug || event.CitySlug;
  const slug = event.slug || event.Slug;
  if (city && slug) return `/e/${city}/${slug}`;

  const code = event.inviteCode || event.InviteCode || event.id || event.Id;
  return code ? `/events/${code}` : null;
}

/** Absolute form, for share sheets and anything that leaves the app. */
export function eventUrl(event, origin) {
  const path = eventPath(event);
  if (!path) return null;
  const base = origin || (webOrigin());
  return `${base}${path}`;
}

export default eventPath;
